import { Injectable } from '@angular/core';
import * as Models from 'app/core/models';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ModalService {

    private _command = new Subject<Models.ModalContext>();
    command$ = this._command.asObservable();

    private _returnEvent = new Subject<any>();
    returnEvent$ = this._returnEvent.asObservable();

    command(data: Models.ModalContext) {
        this._command.next(data);
    }

    returnEvent(data: any) {
        this._returnEvent.next(data);
    }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/modal/modal.service.ts